module.exports = __webpack_public_path__ + "assets/img/INTERIOR2.f5a10cb8.png";